import React from 'react';
import { advantages } from '../mock';

export default function Advantages() {
  return (
    <section id="advantages" className="relative py-24 md:py-36 bg-[#0f0f10] border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-px bg-[#e4cfaf]" />
          <span className="uppercase text-[11px] tracking-[0.28em] text-[#e4cfaf]/90">Our Advantages</span>
        </div>
        <h2 className="serif text-white text-4xl md:text-6xl leading-[1.05] max-w-3xl mb-16 md:mb-20">
          Why landlords <span className="italic-serif">choose us</span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {advantages.map((a) => (
            <div
              key={a.num}
              className="tilt-card bg-[#0f0f10] p-8 md:p-10 min-h-[280px] flex flex-col"
            >
              <div className="serif text-[#e4cfaf] text-3xl mb-6">{a.num}</div>
              <h3 className="serif text-white text-2xl md:text-[26px] mb-4 leading-tight">{a.title}</h3>
              <p className="text-white/60 leading-relaxed text-[15px]">{a.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
